import { render, staticRenderFns } from "./EditAnggota.vue?vue&type=template&id=3ed9ceaf&scoped=true&"
import script from "./EditAnggota.vue?vue&type=script&lang=js&"
export * from "./EditAnggota.vue?vue&type=script&lang=js&"
import style0 from "./EditAnggota.vue?vue&type=style&index=0&id=3ed9ceaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9ceaf",
  null
  
)

export default component.exports